import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthContext } from "@/context/useAuthContext";
import { RoutesList } from "@/router/routesList";
// Не пускаем во вьюхи, если не заполнен профиль
export var ProfileCheckedRoute = function () {
    var isProfileComplete = useAuthContext().isProfileComplete;
    var profilePath = RoutesList.Profile.getUserProfile();
    var location = useLocation();
    if (profilePath !== location.pathname && !isProfileComplete) {
        return _jsx(Navigate, { to: RoutesList.Profile.getUserProfile(), replace: true });
    }
    return _jsx(Outlet, {});
};
